const baseClass = 'ExpandableCardGrid';
const classes = {
	row: `${baseClass}-row`,
	button: `${baseClass}-button`,
	buttonHide: `${baseClass}-button-hide`,
	showall: 'showall',
};
const selectors = {
	row: `.${classes.row}`,
	button: `.${classes.button}`,
	gridComponent: `.${baseClass}`,
};

const setuploadMoreButton = $gridComponent => {
	const $button = $gridComponent.find(selectors.button);
	if ($button.length > 0) {
		$button.on('click', e => {
			e.preventDefault();
			$button.addClass(classes.buttonHide);
			$gridComponent.find(selectors.row).addClass(classes.showall);
			if ($button.data('interactionTracking')) {
				window.FS.Tealium.trackInteraction(
					$button.data('interactionType'),
					$button.data('interactionName'),
					$button.data('interactionDetail')
				);
			}
		});
	}
};

export default function init() {
	$(selectors.gridComponent).each((i, gridComponent) => {
		setuploadMoreButton($(gridComponent));
	});
}
